import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { IVariantInventory, Inventory } from "../../utils/api";
import { useAuth } from "../useAuth";

export const useClearStatusOverride = (
    variantId: string,
): UseMutationResult<IVariantInventory, unknown, void> => {
    const { token } = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IVariantInventory, unknown, void>({
        mutationFn: async () => {
            if (!token) {
                throw new Error(
                    "Cannot release the stock status override without authorization token.",
                );
            }

            return await Inventory.clearStatusOverride({ variantId, token });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["inventory", variantId]);
        },
    });
};
